export default __webpack_public_path__ + "static/0211-878ac397dfadcc033e93ac017cba841a.png";